import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Mi hijo es muy pequeño para entender "emociones"? / Is my child too young?',
  a: 'Nunca es pronto. Si un niño puede sentir frustración, puede empezar a identificarla. El coloreo es el primer paso no verbal para procesar lo que sienten antes de tener el vocabulario completo.'
}, {
  q: '¿Por qué bilingüe? ¿No lo confundirá? / Why bilingual?',
  a: 'Al contrario. Los niños bilingües desarrollan una mayor flexibilidad cognitiva. Darles la palabra en ambos idiomas les permite conectar con su entorno escolar (inglés) y su entorno emocional/familiar (español).'
}, {
  q: '¿Qué hacer si el niño no quiere colorear durante un berrinche? / What if they refuse to color?',
  a: 'No lo fuerces en el pico del grito. Ofrécelo como la "herramienta de calma" una vez que el llanto inicial haya bajado. Con la práctica, se convertirá en su refugio seguro.'
}];
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full py-24 px-6 bg-white" data-id="element-46">
      <div className="max-w-3xl mx-auto" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <h2 className="font-display text-4xl font-bold text-dark mb-4" data-id="element-49">
            Preguntas Frecuentes
          </h2>
          <p className="font-body text-xl text-dark/70" data-id="element-50">
            Frequently Asked Questions
          </p>
        </div>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-2xl overflow-hidden bg-white shadow-sm" data-id="element-52">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-53">
                <span className="font-display font-semibold text-lg text-dark pr-4" data-id="element-54">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-dark/50 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-57">
                    <div className="px-6 pb-5 pt-0 text-dark/70 font-body leading-relaxed border-t border-gray-100 mt-2 pt-4" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};